import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=291575be&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=291575be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291575be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vagrant/git/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291575be')) {
      api.createRecord('291575be', component.options)
    } else {
      api.reload('291575be', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=291575be&scoped=true", function () {
      api.rerender('291575be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recruitment/detail.vue"
export default component.exports